import EventBus from './eventBus'

let shortcuts = [
  {
    // ctrl + s
    event: 'save',
    altKey: false,
    ctrlKey: true,
    keyCode: 83
  },
  {
    // alt + t
    event: 'test',
    altKey: true,
    ctrlKey: false,
    keyCode: 84
  }
]

document.onkeydown = function(evt) {
  evt = evt || window.event
  let target = _.find(shortcuts, {
    altKey: evt.altKey,
    ctrlKey: evt.ctrlKey,
    keyCode: evt.keyCode
  })
  if (target) {
    // 소스 상단에 shortcuts에 정의한 단축키가 실행되면 해당 이벤트를 EventBus로 Publishing한다.
    EventBus.$emit(target.event)
    // 예를 들어 Ctrl+s는 웹 브라우져에서 기본 저장을 의미하는데, 그 뒤에 일어나는 이벤트를 막는다.
    evt.preventDefault()
  }
}
